export default {
  data() {
    return {
      columns: [
        {
          title: '区间（天）',
          dataIndex: 'interval',
          disabled: true,
          width: 400,
          scopedSlots: { customRender: 'interval' },
        },
        {
          title: '审批级别',
          dataIndex: 'creditLevel',
          disabled: true,
          scopedSlots: { customRender: 'creditLevel' },
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'action',
          slotName: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
